import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstLine'
})

// Return first line from paragraph

export class FirstLinePipe implements PipeTransform {

    transform(value: string, args?: any): any {

        if (value) {
            
            const splitLine = value.split('.');
            return splitLine.length > 1 ? splitLine[0] : value;

        }

        return value;
    }

}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/core/pipes/firstLine.pipe.ts